var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBestSeller1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons/40/best_seller"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0067 2.41198C36.6537 1.62644 37.9064 2.03958 37.995 3.01642L38 3.12725V32.3775C38 33.4329 36.6777 33.9074 36.0067 33.0928C31.7607 27.9381 25.5335 24.8187 18.8634 24.5031H15.8582L19.623 32.0333C20.0506 32.8458 19.9248 33.8456 19.3335 34.5355L19.2172 34.6611L16.5359 37.3196C15.4365 38.463 13.5423 38.1164 12.8879 36.6978L12.8266 36.5524L8.30821 24.5031H7.625C7.00368 24.5031 6.5 23.9994 6.5 23.3781V22.2527H3.125C2.54251 22.2527 2.06342 21.81 2.00581 21.2427L2 21.1276V14.3776C2 13.7951 2.44269 13.316 3.00998 13.2584L3.125 13.2526H6.5V12.128C6.5 11.5067 7.00368 11.003 7.625 11.003H18.8345C25.5155 10.6951 31.7546 7.57416 36.0067 2.41198ZM9.12167 22.2524C9.09885 22.2517 9.07595 22.2517 9.053 22.2524H8.75V21.1276V14.3776V13.2523H17.75V22.2524H14.0691C14.0475 22.2518 14.0259 22.2518 14.0042 22.2524H9.12167ZM10.7111 24.5031L14.9276 35.749L14.9328 35.741L17.6295 33.0668L13.343 24.5031H10.7111ZM35.3818 29.1551C31.1747 25.2458 25.7656 22.8283 20 22.3249V13.1798C25.9149 12.6635 31.4547 10.1325 35.7062 6.04289L35.75 5.99918V29.5047L35.3818 29.1551ZM6.5 20.0026L4.25 20.0024V15.5024L6.5 15.5025V20.0026Z",
    fill: "#9DC92A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0067 2.41198C36.6537 1.62644 37.9064 2.03958 37.995 3.01642L38 3.12725V32.3775C38 33.4329 36.6777 33.9074 36.0067 33.0928C31.7607 27.9381 25.5335 24.8187 18.8634 24.5031H15.8582L19.623 32.0333C20.0506 32.8458 19.9248 33.8456 19.3335 34.5355L19.2172 34.6611L16.5359 37.3196C15.4365 38.463 13.5423 38.1164 12.8879 36.6978L12.8266 36.5524L8.30821 24.5031H7.625C7.00368 24.5031 6.5 23.9994 6.5 23.3781V22.2527H3.125C2.54251 22.2527 2.06342 21.81 2.00581 21.2427L2 21.1276V14.3776C2 13.7951 2.44269 13.316 3.00998 13.2584L3.125 13.2526H6.5V12.128C6.5 11.5067 7.00368 11.003 7.625 11.003H18.8345C25.5155 10.6951 31.7546 7.57416 36.0067 2.41198ZM9.12167 22.2524C9.09885 22.2517 9.07595 22.2517 9.053 22.2524H8.75V21.1276V14.3776V13.2523H17.75V22.2524H14.0691C14.0475 22.2518 14.0259 22.2518 14.0042 22.2524H9.12167ZM10.7111 24.5031L14.9276 35.749L14.9328 35.741L17.6295 33.0668L13.343 24.5031H10.7111ZM35.3818 29.1551C31.1747 25.2458 25.7656 22.8283 20 22.3249V13.1798C25.9149 12.6635 31.4547 10.1325 35.7062 6.04289L35.75 5.99918V29.5047L35.3818 29.1551ZM6.5 20.0026L4.25 20.0024V15.5024L6.5 15.5025V20.0026Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 40,
    height: 40,
    fill: "#47D5CD"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestSeller1X);
export default __webpack_public_path__ + "static/media/best_seller@1x.56eca06b16d6d4a3597c9367932114ac.svg";
export { ForwardRef as ReactComponent };